/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
            wishlists: "plus"
        },
        window.boostSDAppConfig.integration || {}
    );
}
// if (window.boostSDAppConfig) {
//   window.boostSDAppConfig.integration = Object.assign(
//     {
//       wishlists: "i-wishlist",
//     },
//     window.boostSDAppConfig.integration || {}
//   );
// }
const customize = {
    updateBtns: (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductItem", {
            name: "Modify Product Buttons",
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    let product_id = element.getParams().props.product.id;
                    //let productItem = document.querySelector('[data-product-id="' + product_id + '"]');
                    let productItems = document.querySelectorAll(
                        '.boost-sd__product-item[data-product-id="' + product_id + '"]'
                    );
                    let productData = element.getParams().props.product;
                    let productDataHandle1 = productData.collections.findIndex(
                        (data) => data.handle === "custom-label-one"
                    );
                    let productDataHandle2 = productData.collections.findIndex(
                        (data) => data.handle === "custom-label-two"
                    );
                    productItems.forEach(function(el) {
                        let productItem = el;
                        if (productDataHandle1 > -1 && productDataHandle2 > -1) {
                            productItem.querySelector(
                                    ".boost-sd__product-image-row--top"
                                ).innerHTML =
                                '<div class="price-ui-badge price-ui-badge--custom-label-one custom-one"><div class="price-ui-badge__sticker price-ui-badge__sticker--custom-label-one"><span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--custom-label-one">40% OFF</span></div></div><div class="price-ui-badge price-ui-badge--custom-label-two"><div class="price-ui-badge__sticker price-ui-badge__sticker--custom-label-two"><span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--custom-label-two">FINAL CLEARANCE</span></div></div>';
                        } else if (productDataHandle1 > -1) {
                            productItem.querySelector(
                                    ".boost-sd__product-image-row--top"
                                ).innerHTML =
                                '<div class="price-ui-badge price-ui-badge--custom-label-one"><div class="price-ui-badge__sticker price-ui-badge__sticker--custom-label-one"><span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--custom-label-one">40% OFF</span></div></div>';
                        } else if (productDataHandle2 > -1) {
                            productItem.querySelector(
                                    ".boost-sd__product-image-row--top"
                                ).innerHTML =
                                '<div class="price-ui-badge price-ui-badge--custom-label-two"><div class="price-ui-badge__sticker price-ui-badge__sticker--custom-label-two"><span class="price-ui-badge__sticker-text price-ui-badge__sticker-text--custom-label-two">FINAL CLEARANCE</span></div></div>';
                        }
                        
                        let wishListHTML = productItem.querySelector(".boost-sd__wishlist")
                        const cloneWishList = wishListHTML.cloneNode(true);
                        cloneWishList.classList.add("boost-sd__wishlist-custom");
                        // cloneWishList.querySelector('.iWishAddColl').innerHTML = '<svg height="25px" width="25px" style="stroke:currentColor;stroke-width: 10px;" id="Layer_1" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M340.8,98.4c50.7,0,91.9,41.3,91.9,92.3c0,26.2-10.9,49.8-28.3,66.6L256,407.1L105,254.6c-15.8-16.6-25.6-39.1-25.6-63.9  c0-51,41.1-92.3,91.9-92.3c38.2,0,70.9,23.4,84.8,56.8C269.8,121.9,302.6,98.4,340.8,98.4 M340.8,83C307,83,276,98.8,256,124.8  c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6L245.1,418l10.9,11l10.9-11l148.3-149.8  c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"></path></svg> <svg class="added" height="25px" width="25px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M340.8,83C307,83,276,98.8,256,124.8c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6  L245.1,418l10.9,11l10.9-11l148.3-149.8c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"></path></svg>';
                        if (!productItem.querySelector(".boost-sd__wishlist-custom")) {
                            productItem.querySelector(".boost-sd__product-image").insertAdjacentHTML("afterbegin", cloneWishList.outerHTML)
                        }

                        /* Start-Boost-655908 */
                        const foundVideo = productData.media.filter(function(e) {
                            return e.mediaContentType == 'VIDEO';
                        })
                        if (typeof foundVideo[0] !== 'undefined') {
                            let html = '<div class="boost-sd__video">';
                            html += '<video playsinline="playsinline" autoplay="autoplay" preload="none" loop="loop" muted="muted" aria-label="{{itemTitle}}" poster="' + foundVideo[0]['preview']['image']['originalSrc'] + '">';
                            html += '<source src="' + foundVideo[0]['sources'][0]['url'] + '" type="video/mp4">';
                            html += '<img src="' + foundVideo[0]['preview']['image']['originalSrc'] + '">';
                            html += '</video>';
                            html += '</div>';
                            if (el.querySelector('.boost-sd__product-image-img--second') && !el.querySelector('.boost-sd__product-image .boost-sd__video')) {
                                el.querySelector('.boost-sd__product-image-img--second').remove();
                                el.querySelector('.boost-sd__product-image').insertAdjacentHTML('beforeend', html);
                            }
                        }
                        /* End-Boost-655908 */
                    });
                },
            }),
        });
    },
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customize.updateBtns,
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        const changeProductImageResolution = {
            name: "Change Product Image resolution",
            apply() {
                return {
                    props(props) {
                        props.deviceSizes = [200, 300, 400, 800, 1000, 1200, 1600];
                        props.imageSizes = [400, 600, 800];
                        console.log(props);
                        return props;
                    },
                };
            },
        };
        componentRegistry.useComponentPlugin(
            "HeaderImage",
            changeProductImageResolution
        );
    },
]);
/* Boost-228098 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin("ProductSwatch", {
            name: "Customize swatches",
            enabled: true,
            apply: () => ({
                props: (props) => {
                    props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
                    return props;
                },
                afterRender(element) {
                    try {
                        const swatchOptions = element?.getParams()?.props?.options;
                        const productData =
                            componentRegistry
                            .getNearestParentElm(element, "ProductItemWidget")
                            ?.getParams()?.props?.product ||
                            componentRegistry
                            .getNearestParentElm(element, "QuickView")
                            ?.getParams()?.props?.productData;
                        if (swatchOptions?.length && productData) {
                            const productVariants = productData.variants || [];
                            swatchOptions.forEach((option) => {
                                const optionValue = option.value;
                                option.available = checkOptionStatus(
                                    productVariants,
                                    optionValue
                                );
                                if (!option.available) {
                                    const swatchOption = document.querySelector(
                                        `label[for*="${option.id}"]`
                                    );
                                    if (
                                        swatchOption &&
                                        swatchOption.closest(".boost-sd__product-swatch-option")
                                    ) {
                                        swatchOption
                                            .closest(".boost-sd__product-swatch-option")
                                            .classList.add("sold-out");
                                    }
                                }
                            });
                        }
                    } catch (error) {
                        console.log(error);
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin("ProductImage", {
            name: "Customize swatches",
            enabled: true,
            apply: () => ({
                props: (props) => {
                    console.log(props)
                    return props;
                }
            }),
        });
    },
]);

function checkOptionStatus(variants, optionValue) {
    for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        const variantOptions = variant.title?.split(" / ") || [];
        if (
            variantOptions.some(
                (option) =>
                option.toLowerCase() === optionValue.toLowerCase() &&
                variant.available
            )
        ) {
            return true;
        }
    }
    return false;
}
/* Boost-228098 */